import { eamEfaDashboardApi } from 'api';

export const getEamEfaDashboardData = async (partnerNumber: string): Promise<{ url: string }> => {
  const response = await eamEfaDashboardApi.getEamEfaDashboard({ partnerId: partnerNumber });
  return response as unknown as { url: string };
};
